import { __awaiter } from "tslib";
import { WebSocketApiWithAuth } from 'src/services/api/reallis/WebSocketApiWithAuth';
import { WebSocketApi } from 'src/services/api/common/ws/WebSocketApi';
import { UserController } from 'src/services/api/reallis/UserController';
import { WebSocketError } from 'src/services/api/common/ws/WebSocketError';
export const webSocketRequestParamsDefault = {
    timeout: 60000,
    requestDataToString(requestData) {
        return JSON.stringify(requestData);
    },
    responseDataFromString(responseDataStr) {
        return JSON.parse(responseDataStr);
    },
    setRequestId(requestData, requestId) {
        return Object.assign(Object.assign({}, requestData), { id: requestId });
    },
    getRequestId(responseData) {
        return responseData.result.request.id;
    },
    validate(responseData) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (responseData
            && responseData.result
            && responseData.result.response
            && responseData.result.response.type === 'Right') {
            return null;
        }
        let data = (_c = (_b = (_a = responseData === null || responseData === void 0 ? void 0 : responseData.result) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.data;
        let message = (_f = (_e = (_d = responseData === null || responseData === void 0 ? void 0 : responseData.result) === null || _d === void 0 ? void 0 : _d.response) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.msg;
        let code = (_j = (_h = (_g = responseData === null || responseData === void 0 ? void 0 : responseData.result) === null || _g === void 0 ? void 0 : _g.response) === null || _h === void 0 ? void 0 : _h.value) === null || _j === void 0 ? void 0 : _j.type;
        if (message && typeof message !== 'string') {
            if (message.error) {
                code = code ? code + '.' + message.error : message.error;
            }
            message = message.error_description || message.errorMessage;
        }
        if (Array.isArray(data)) {
            data = data.join('\r\n').trim();
        }
        if (data) {
            message = message
                ? message + '\r\n' + data
                : data;
        }
        return {
            code,
            message,
        };
    },
};
export class Api extends WebSocketApiWithAuth {
    constructor({ url, }) {
        super({
            api: new WebSocketApi({
                url,
                requestParamsDefault: webSocketRequestParamsDefault,
            }),
        });
        this.user = new UserController({ api: this });
        this.user.profileUpdate();
    }
    login(args) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.auth.login(args);
                yield this.user.profileUpdate();
            }
            catch (err) {
                this.auth.logout();
                throw err;
            }
            if (this.user.profile.isBanned) {
                throw new WebSocketError('User is banned', 'user-banned');
            }
        });
    }
}
